import { useState, useEffect } from "react";
import { GetVendorNameList } from "services/vendor/vendor.service";
import { GetEmployeeNameList } from "services/employee/employee.service";
import { useSelector, useDispatch } from "react-redux";

const useItemDropdown = (showForm) => {
    const dispatch = useDispatch();
    
    const { vendorNameList } = useSelector((state) => state.vendorNameList);
    const { employeeNameList } = useSelector((state) => state.employeeNameList);

    const [vendorNameDropdown, setVendorNameDropdown] = useState([]);
    const [employeeNameDropdown, setEmployeeNameDropdown] = useState([]);

    useEffect(() => {
        if(showForm){
            dispatch(GetVendorNameList());
            dispatch(GetEmployeeNameList());
        }
    }, [showForm, ]);

    return {
        vendorNameDropdown, 
        setVendorNameDropdown, 
        employeeNameDropdown,
        setEmployeeNameDropdown,
        vendorNameList,
        employeeNameList,

    };
};

export default useItemDropdown;
